<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

               <v-card>

                   <v-breadcrumbs divider="/">
                       <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                       <v-breadcrumbs-item :disabled="true">Unosi</v-breadcrumbs-item>
                   </v-breadcrumbs>

               </v-card>

                <v-card class="m-20" v-if="costs">

                    <v-card-title>

                        <v-layout>

                            <v-flex xs4 pr-4>

                                <v-select
                                        @change="getCosts()"
                                        :items="months"
                                        label="Meseci"
                                        v-model="month"
                                        item-text="dateText"
                                        item-value="date"
                                ></v-select>

                            </v-flex>


                        </v-layout>

                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="costs"
                            :pagination.sync="pagination"
                            :rows-per-page-items=[50,25,10]
                            hide-actions
                            class="elevation-1"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.created_at }}</td>
                            <td class="text-xs-left">{{ props.item.sum }}</td>
                            <td class="text-xs-right">

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="secondary" class="black&#45;&#45;text" :to="'/users/' + props.item.id + '/edit'" v-if="checkGuard('user-edit')">-->
                                    <v-btn slot="activator" small color="secondary" class="black--text" :to="'/costs/' + props.item.created_at.split(' ')[0] + '/lists'">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Po danu</span>
                                </v-tooltip>

                            </td>
                        </template>

                    </v-data-table>

                </v-card>

            </v-flex>

            <!--<v-fab-transition v-if="checkGuard('user-create')">-->
            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/costs/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>


        </v-layout>
    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                loading: true,
                month: 0,
                months: [],
                pagination: {
                    descending: true,
                },
                costs: false,
                days: [],
                headers: [
                    {text: 'DATUM', align: 'left', sortable: true, value: 'created_at'},
                    {text: 'BILANS', sortable: true, value: 'sum'},
                    {text: 'AKCIJA', align: 'right', value: 'action'},
                ],
            }
        },
        mounted() {
            this.getCosts();
            // this.getDays();
        },
        computed: {
            user(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getCosts() {
                this.loading = true;

                axios.get('costs?month=' + this.month)
                    .then(res => {
                        this.costs = res.data.costs;
                        this.months = res.data.months;
                        this.loading = false;
                    }).catch(e => {
                        console.log(e.response);
                        this.error = e.response.data.errors;
                    });
            },
            checkGuard(name){
                let res = false;
                let permissionList = this.$store.getters['ability/getPermissionList'];
                permissionList.forEach(permission => {
                    if(name === permission.name){
                        res = true;
                    }
                });
                return res;
            },
        },
        watch: {
            pagination: {
                handler () {
                    this.getCosts();
                },
                deep: true
            },
        },
    }
</script>

<style scoped>
    .swal2-styled.swal2-confirm{
        border-radius: 0 !important;
    }
</style>
